import { render, staticRenderFns } from "./MerchantPlatform.vue?vue&type=template&id=329ac4c9"
import script from "./MerchantPlatform.vue?vue&type=script&lang=js"
export * from "./MerchantPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports